import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import Table from '../components/Table';
import { UsersListApi } from '../redux/actions/User/UserListAction';
import { useLocation } from 'react-router-dom';

const CustomerManagement = () => {
    const columns = [
        "Customer Name",
        "Total Purchases",
        "Country",
        "Email",
        "Status",
        "Action",
    ]
    const dispatch = useDispatch();
    const location = useLocation();
    const [deleted, setDeleted] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const [totalPages, setTotalPages] = useState(1);
    const [items, setItems] = useState(5);

    const [limit, setLimit] = useState(5);

    const searchTerm = useSelector((state) => state.search.term);
    const statusTerm = useSelector((state) => state.status.term);

    const { loading, response, error } = useSelector((state) => state.usersList);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchUsersList = useCallback(() => {
        let role;
        dispatch(UsersListApi(currentPage, limit, role = "customer", searchTerm, statusTerm));
    }, [currentPage, limit, searchTerm, statusTerm, dispatch, location.pathname]);

    useEffect(() => {
        fetchUsersList();
    }, [currentPage, limit, statusTerm, searchTerm, fetchUsersList, deleted])

    console.log(response, "response")

    useEffect(() => {
        setCurrentPage(1);
    }, [location.pathname, statusTerm, searchTerm]);

    useEffect(() => {
        if (response?.status === true) {
            setTotalPages(response?.data?.totalPages);
            setCurrentPage(response?.data?.currentPage);
            setItems(response?.data?.totalItems)
        }
    }, [response])
    return (
        <>
            {
                loading
                    ? (
                        <div
                            style={{ height: "70vh" }}
                            className="d-flex align-items-center justify-content-center"
                        >
                            <PulseLoader size={25} color="#0f0a30" />
                        </div>
                    ) : error ? (
                        <div
                            style={{ height: "70vh" }}
                            className="d-flex align-items-center justify-content-center"
                        >
                            <p className="text-danger">Something went wrong</p>
                        </div>
                    ) : (
                        <Table
                            title='Customer'
                            tableData={response?.data}
                            limit={limit}
                            items={items}
                            columns={columns}
                            totalPages={totalPages}
                            currentPage={currentPage}
                            handlePageChange={handlePageChange}
                            role='customer'
                            statusTerm={statusTerm}
                            setDeleted={setDeleted}
                        />

                    )}
        </>
    )
}

export default CustomerManagement